export const getPriceForPackage = (packageType, priceForPackages) => {
  const packageId =
    typeof packageType === "number" ? packageType : packageType.id;

  return priceForPackages.find(
    priceForPackage => priceForPackage.packageId === packageId,
  );
};
